// src/components/AdminLayout.js
import React, { useEffect } from "react";
import AdminHeader from "./AdminHeader";

export default function AdminLayout({ children }) {
  // Prevent horizontal scroll on entire document
  useEffect(() => {
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-rose-50 flex flex-col overflow-x-hidden">
      {/* Unified Branded Admin Header */}
      <AdminHeader />

      {/* Main Content Area */}
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 py-6 md:py-10 overflow-x-hidden">
        <div className="w-full overflow-x-auto">
          {children}
        </div>
      </main>
    </div>
  );
}
